module.exports = __webpack_public_path__ + "static/media/ico-pinterest.60a28577.svg";